import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Booking from 'models/booking';

const propTypes = {
  booking: PropTypes.instanceOf(Booking).isRequired,
  hideTextLabel: PropTypes.bool,
  isTwoLines: PropTypes.bool,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
};

const defaultProps = {
  hideTextLabel: false,
  isTwoLines: false,
  className: 'text-size-10 padding-top-20',
  labelClassName: 'text-size-12 text-weight-book',
};

const parkingTime = (isTimeTBD, timeToDisplay, isTwoLines) => {
  if (isTimeTBD) {
    return <span className="text-weight-bold">TBD</span>;
  }

  return (
    <Fragment>
      <span className="text-weight-bold">{timeToDisplay.format('ddd MMM D ')}</span>
      <br className={cx({ hidden: !isTwoLines })} />
      <span>{timeToDisplay.format('h:mm A')}</span>
    </Fragment>
  );
};

const ParkingTimes = ({ booking, hideTextLabel, isTwoLines, className, labelClassName }) => {
  const labelClasses = cx({
    'padding-right-0': true,
    'col-xs-5': !hideTextLabel,
    'col-xs-3': hideTextLabel,
  });

  const valueClasses = cx({
    'padding-right-0': true,
    'padding-0-xs': true,
    'col-xs-7': !hideTextLabel,
    'col-xs-9': hideTextLabel,
    'text-weight-book': true,
  });

  if (booking.isMonthly) {
    const monthlyName = booking.monthlyPricing && booking.monthlyPricing.name ? booking.monthlyPricing.name : 'Monthly';

    return (
      <div className={`parking-times uppercase ${className}`}>
        <div className="row">
          <div className="col-xs-6 padding-right-0">{monthlyName}</div>
          <div className="weak col-xs-6 padding-right-0 padding-0-xs">
            <span>{booking.startTime.format('ddd MMM D ')}</span>
            <br />
            <span className="text-size-10">THROUGH</span>
            <br />
            <span>{booking.endTime.format('ddd MMM D ')}</span>
          </div>
        </div>
      </div>
    );
  }

  let entryLabel;
  let exitLabel;

  if (!hideTextLabel) {
    entryLabel = booking.onDemand ? 'Entry' : 'In After';
    exitLabel = booking.onDemand ? 'Exit' : 'Out By';
  }

  return (
    <div className={`parking-times uppercase ${className}`}>
      <div className="row">
        <div className={`arrival ${labelClassName} ${labelClasses}`}>{entryLabel}</div>
        <div className={valueClasses}>
          { parkingTime(booking.hasTBDTimes, booking.startTime, isTwoLines) }
        </div>
      </div>
      <div className="row">
        <div className={`departure ${labelClassName} ${labelClasses}`}>{exitLabel}</div>
        <div className={valueClasses}>
          { parkingTime(booking.hasTBDTimes, booking.endTime, isTwoLines) }
        </div>
      </div>
    </div>
  );
};

ParkingTimes.propTypes = propTypes;
ParkingTimes.defaultProps = defaultProps;
export default ParkingTimes;
